module.exports = __webpack_public_path__ + "static/media/menu.af802ed4.svg";